import { Spinner } from "@chakra-ui/core";
import {
	CircularProgress,
	CircularProgressLabel,
} from "@chakra-ui/react";

interface UploadProgressProps {
	error: boolean;
	progress: number;
	onRetry?: () => void;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({
	progress,
	error,
	onRetry,
}) => {
	if (error) {
		return (
			<button
				type="button"
				onClick={onRetry}
				className="text-sm font-semibold text-red-600 hover:text-red-800"
			>
				Retry
			</button>
		);
	}

	if (progress === 0) {
		return <Spinner size="sm" color="blue.500" />;
	}

	return (
		<CircularProgress
			value={progress}
			size="40px"
			thickness="8px"
			color="blue.500"
			trackColor="gray.200"
		>
			<CircularProgressLabel fontSize="xs" fontWeight="semibold">
				{Math.round(progress)}%
			</CircularProgressLabel>
		</CircularProgress>
	);
};
